const STIFFNESS = 100;
const DAMPING = 10;
const MASS = 1;

export function createSpring(readTarget, write) {
  const state = { x: 0, y: 0, vx: 0, vy: 0 };
  let frame = 0;
  let last = 0;

  const step = (now) => {
    const dt = Math.min(0.032, last ? (now - last) / 1000 : 0.016);
    last = now;
    const target = readTarget();
    const ax = (-STIFFNESS * (state.x - target.x) - DAMPING * state.vx) / MASS;
    const ay = (-STIFFNESS * (state.y - target.y) - DAMPING * state.vy) / MASS;
    state.vx += ax * dt;
    state.vy += ay * dt;
    state.x += state.vx * dt;
    state.y += state.vy * dt;
    write(state.x, state.y);

    const settled = Math.hypot(state.x - target.x, state.y - target.y) < 0.04
      && Math.hypot(state.vx, state.vy) < 0.04;
    if (settled) {
      state.x = target.x;
      state.y = target.y;
      state.vx = 0;
      state.vy = 0;
      write(state.x, state.y);
      frame = 0;
      last = 0;
      return;
    }
    frame = requestAnimationFrame(step);
  };

  return {
    kick() {
      if (!frame) frame = requestAnimationFrame(step);
    },
    stop() {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      last = 0;
    },
  };
}
